import { CardLinkVariant } from 'consumer-page-widgets/CardLinkWidget/CardLink';
import { Theme, css } from '@emotion/react';

export const IMAGE_MAX_WIDTH_DESKTOP = 280;
export const LARGE_IMAGE_MAX_WIDTH_DESKTOP = 500;

export const IMAGE_WIDTH_MOBILE_PERCENTAGE = '48%';
export const LARGE_IMAGE_WIDTH_MOBILE_PERCENTAGE = '80%';

export const cardLinkCssDefs = {
  widgetContainer: ({ breakpoints }: Theme) => css`
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    & > * + * {
      margin-top: 20px;
    }

    ${breakpoints.up('md')} {
      flex-direction: row;
      margin: 40px 0;

      & > * + * {
        margin-top: 0;
        margin-left: 24px;
      }
    }
  `,
  cardContainer: ({ breakpoints, spacing, colors }: Theme) => css`
    position: relative;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;

    flex: 1;

    border: 1px solid ${colors.borderDefault};

    ${breakpoints.up('sm')} {
      flex-direction: row;
      padding: 0;
    }
  `,
  anchor: css`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
  `,
  imageContainerOuter:
    (variant: CardLinkVariant) =>
    ({ spacing, breakpoints }: Theme) => [
      css`
        display: block;
        position: relative;
        overflow: hidden;

        height: auto;
        width: ${variant === 'large'
          ? LARGE_IMAGE_WIDTH_MOBILE_PERCENTAGE
          : IMAGE_WIDTH_MOBILE_PERCENTAGE};

        flex: 1 0 calc(50% - ${spacing(6)}px);
        order: 2;
        align-self: ${variant === 'large' ? 'flex-start' : 'flex-end'};

        ${breakpoints.up('sm')} {
          max-width: ${variant === 'large'
            ? LARGE_IMAGE_MAX_WIDTH_DESKTOP
            : IMAGE_MAX_WIDTH_DESKTOP}px;

          align-self: stretch;
          order: initial;
          margin-right: ${spacing(6)}px;
        }
      `,
      variant === 'default' &&
        css`
          margin: 0 ${spacing(3)}px ${spacing(3)}px;

          ${breakpoints.up('sm')} {
            margin: 0;
            margin-right: ${spacing(6)}px;
          }
        `,
    ],
  imageContainerInner:
    (variant: CardLinkVariant) =>
    ({ utils }: Theme) => [
      variant === 'large' ? utils.aspectRatio(4, 5) : utils.aspectRatio(2, 3),
      css`
        height: 100%;
        width: 100%;
        object-fit: cover;
      `,
    ],
  image: css`
    height: 100%;
    display: block;
    width: 100%;
    object-fit: cover;
    object-position: center;
  `,
  contentContainer:
    (variant: CardLinkVariant) =>
    ({ breakpoints, spacing }: Theme) => css`
      flex: 1 1 calc(50% + ${spacing(8)}px);

      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      order: 1;

      padding: ${spacing(4.5)}px ${spacing(3)}px ${spacing(variant === 'large' ? 3.5 : 2)}px;
      overflow: hidden;

      ${breakpoints.up('sm')} {
        order: initial;

        padding: ${spacing(6)}px ${spacing(4)}px ${spacing(6)}px 0;
        margin: 0;
      }
    `,
  button:
    (variant: CardLinkVariant) =>
    ({ breakpoints, spacing, zIndex }: Theme) => [
      css`
        position: absolute;
        bottom: ${spacing(6)}px;
        max-width: 100%;
        z-index: ${2 * zIndex.bump};

        ${breakpoints.up('sm')} {
          position: static;
          margin-top: ${spacing(2)}px;
        }
      `,
      variant === 'default' &&
        css`
          left: ${spacing(3)}px;
        `,
      variant === 'large' &&
        css`
          right: ${spacing(3)}px;
        `,
    ],
  buttonMobile: ({ breakpoints }: Theme) => css`
    ${breakpoints.up('sm')} {
      display: none;
    }
  `,
  buttonDesktop: ({ breakpoints }: Theme) => css`
    display: none;

    ${breakpoints.up('sm')} {
      display: flex;
    }
  `,
};
